// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".theme_light {\r\n}\r\n\r\n.theme_dark {\r\n}\r\n", ""]);
// Exports
module.exports = exports;
